// extracted by mini-css-extract-plugin
module.exports = {"column":"_2YoJaTfFtd9QLk3Ta2LsmJ","btnAddItem":"_1TG-Vm3WLjYeeGVTrO-lM_","boxBtnEditColumn":"_1p7SoN8WAlxbwJm0ujzQTZ","btnEditColumn":"_1YJi0080iFIJcxc8xX2fDL"};